export interface LinkedWorkbookFilter {
  type: string;
  linkedFilters: { id: string; bound?: string }[];
}

export const filterIdSeparator = "---";

export const getWorkbookFilterParameterId = (reportId: string, parameterId: string) => {
  return `${reportId}${filterIdSeparator}${parameterId}`;
};

export const getReportIdFromWorkbookFilterParameterId = (workbookFilterParameterId: string) => {
  return workbookFilterParameterId.split(filterIdSeparator)[0];
};

export const getTextWorkbookFilter = <T extends LinkedWorkbookFilter>(
  workbookFilters: T[],
  reportId: string,
  parameterId: string
) => {
  return workbookFilters.find(
    (wf) =>
      wf.type === "Table" &&
      wf.linkedFilters.some((lf) => lf.id === getWorkbookFilterParameterId(reportId, parameterId) && lf.bound === "In")
  );
};

export const getDateFromWorkbookFilter = <T extends LinkedWorkbookFilter>(
  workbookFilters: T[],
  reportId: string,
  parameterId: string
) => {
  return workbookFilters.find((wf) =>
    wf.linkedFilters.some((lf) => lf.id === getWorkbookFilterParameterId(reportId, parameterId) && lf.bound === "From")
  );
};

export const getDateToWorkbookFilter = <T extends LinkedWorkbookFilter>(
  workbookFilters: T[],
  reportId: string,
  parameterId: string
) => {
  return workbookFilters.find((wf) =>
    wf.linkedFilters.some((lf) => lf.id === getWorkbookFilterParameterId(reportId, parameterId) && lf.bound === "To")
  );
};
